export function notificationSchedules() {
  const result = [];
  for (let i = 4; i <= 24; i++) {
    const isPm = i >= 12 && i <= 23;
    const amPm = isPm ? 'PM' : 'AM';
    result.push({
      name: `${(i > 12 ? i - 12 : i)} ${amPm}`,
      value: String(i),
    });
  }

  return result;
}
